export * from "./no-content-msg/no-content-msg.component";
